import React from 'react'
import PropTypes from 'prop-types'

import BusinessSectionTopTitle from './business-section-top-title'
import BusinessSectionTopSubtitle from './business-section-top-subtitle'

const BusinessSectionTop = ({ title, subtitle, topText, topGreen, isH1 }) => {
  return (
    <div className="tc mb6">
      <BusinessSectionTopTitle
        title={title}
        topText={topText}
        topGreen={topGreen}
        isH1={isH1}
      />
      <BusinessSectionTopSubtitle subtitle={subtitle} />
    </div>
  )
}

BusinessSectionTop.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.node,
  topText: PropTypes.string,
  topGreen: PropTypes.bool,
  isH1: PropTypes.bool
}

export default BusinessSectionTop



// WEBPACK FOOTER //
// ./src/components/business-section/business-section-top/business-section-top.js